/* @generated from adl module ferovinum.app.productsaleorder */

import * as ADL from './../../runtime/adl';
import * as common_db from './../../common/db';
import * as ferovinum_app_db from './db';
import * as ferovinum_app_dtos from './dtos';

export interface ProductSaleOrder {
  productId: common_db.DbKey<ferovinum_app_db.Product>;
  unitsOrdered: ferovinum_app_db.NumberOfUnits;
  /**
   * Optionally allow the user to select which attributes to pick the stock based on
   */
  attributeSelection: (ferovinum_app_dtos.SaveProductStockDetailDto[]|null);
}

export function makeProductSaleOrder(
  input: {
    productId: common_db.DbKey<ferovinum_app_db.Product>,
    unitsOrdered: ferovinum_app_db.NumberOfUnits,
    attributeSelection?: (ferovinum_app_dtos.SaveProductStockDetailDto[]|null),
  }
): ProductSaleOrder {
  return {
    productId: input.productId,
    unitsOrdered: input.unitsOrdered,
    attributeSelection: input.attributeSelection === undefined ? null : input.attributeSelection,
  };
}

const ProductSaleOrder_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.productsaleorder","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"productId","default":{"kind":"nothing"},"name":"productId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"Product"}},"parameters":[]}]}},{"annotations":[],"serializedName":"unitsOrdered","default":{"kind":"nothing"},"name":"unitsOrdered","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"NumberOfUnits"}},"parameters":[]}},{"annotations":[{"value":"Optionally allow the user to select which attributes to pick the stock based on\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"serializedName":"attributeSelection","default":{"kind":"just","value":null},"name":"attributeSelection","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.dtos","name":"SaveProductStockDetailDto"}},"parameters":[]}]}]}}]}},"name":"ProductSaleOrder","version":{"kind":"nothing"}}};

export const snProductSaleOrder: ADL.ScopedName = {moduleName:"ferovinum.app.productsaleorder", name:"ProductSaleOrder"};

export function texprProductSaleOrder(): ADL.ATypeExpr<ProductSaleOrder> {
  return {value : {typeRef : {kind: "reference", value : snProductSaleOrder}, parameters : []}};
}

export const _AST_MAP: { [key: string]: ADL.ScopedDecl } = {
  "ferovinum.app.productsaleorder.ProductSaleOrder" : ProductSaleOrder_AST
};
